import React, { createContext, useContext } from "react";

type FeatureFlags = {
  newProfileView: boolean;
};

const FeatureFlagContext = createContext<FeatureFlags>({
  newProfileView: process.env.REACT_APP_NEW_PROFILE_VIEW === "true",
});

export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const featureFlags: FeatureFlags = {
    newProfileView: process.env.REACT_APP_NEW_PROFILE_VIEW === "true",
  };

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagContext);